<template>
  <div class="container">
    <div v-for="(ponto, index) in pontosDistritos" :key="index">
      <span v-if="ponto.type == 'TANQUE'">
        <Reservatorio
          :Type="ponto.type"
          :ID="ponto.id"
          :Max="ponto.max_reservatorio"
          :Res="ponto.value"
          :Nome="ponto.nome_ponto"
          :Top="ponto.sup_top"
          :Left="ponto.sup_left"
          :Height="ponto.height"
          :Width="ponto.width"
          :Angle="ponto.sup_angle"
          :Enabled="false"
        />
      </span>
      <span v-else-if="ponto.type == 'BOMBA'">
        <Bomba
          :ID="ponto.id"
          :Nome="ponto.nome_ponto"
          :Status="ponto.value"
          :Top="ponto.sup_top"
          :Left="ponto.sup_left"
          :Height="ponto.height"
          :Width="ponto.width"
          :Angle="ponto.sup_angle"
          :Enabled="false"
        />
      </span>
      <span v-else-if="ponto.type == 'BOMBA_POCO'">
        <BombaPoco
          :ID="ponto.id"
          :Nome="ponto.nome_ponto"
          :Status="ponto.value"
          :Top="ponto.sup_top"
          :Left="ponto.sup_left"
          :Height="ponto.height"
          :Width="ponto.width"
          :Angle="ponto.sup_angle"
          :Enabled="false"
        />
      </span>
      <span v-else-if="ponto.type == 'CONTATO'">
        <Reservatorio
          :ID="ponto.id"
          :Max="ponto.max_reservatorio"
          :Res="ponto.value"
          :Nome="ponto.nome_ponto"
          :Top="ponto.sup_top"
          :Left="ponto.sup_left"
          :Height="ponto.height"
          :Width="ponto.width"
          :Angle="ponto.sup_angle"
          :Enabled="false"
        />
      </span>
      <span v-else-if="ponto.type == 'CANO'">
        <Cano
          :ID="ponto.id"
          :Res="ponto.value"
          :Nome="ponto.variable"
          :Top="ponto.sup_top"
          :Left="ponto.sup_left"
          :Height="ponto.height"
          :Width="ponto.width"
          :Angle="ponto.sup_angle"
          :Enabled="false"
        />
      </span>
      <span v-if="ponto.type == 'JUNCAOL'">
        <Juncao
          :ID="ponto.id"
          :Nome="ponto.variable"
          :Max="ponto.max_reservatorio"
          :Res="ponto.value"
          :Top="ponto.sup_top"
          :Left="ponto.sup_left"
          :Height="ponto.height"
          :Width="ponto.width"
          :Angle="ponto.sup_angle"
          :Type="ponto.type"
          :Enabled="false"
        />
      </span>
      <span v-if="ponto.type == 'JUNCAOT'">
        <Juncao
          :ID="ponto.id"
          :Nome="ponto.variable"
          :Max="ponto.max_reservatorio"
          :Res="ponto.value"
          :Top="ponto.sup_top"
          :Left="ponto.sup_left"
          :Height="ponto.height"
          :Width="ponto.width"
          :Angle="ponto.sup_angle"
          :Type="ponto.type"
          :Enabled="false"
        />
      </span>

      <span v-if="ponto.type == 'DISTRIBUICAO'">
        <Distribuicao
          :ID="ponto.id"
          :Nome="ponto.variable"
          :Max="ponto.max_reservatorio"
          :Res="ponto.value"
          :Top="ponto.sup_top"
          :Left="ponto.sup_left"
          :Height="ponto.height"
          :Width="ponto.width"
          :Angle="ponto.sup_angle"
          :Type="ponto.type"
          :Enabled="false"
        />
      </span>
    </div>

    <div v-if="pontosDistritos != null && pontosDistritos.length > 0">
      <span>
        <Caixa
          ID="Douradinho"
          Titulo="DOURADINHO"
          Top="104"
          Left="400"
          Height="50"
          Width="178"
          Angle="0"
          :Enabled="false"
        />
      </span>
      <span>
        <Caixa
          ID="Caiana"
          Titulo="Caiana"
          Top="104"
          Left="964"
          Height="50"
          Width="178"
          Angle="0"
          :Enabled="false"
        />
      </span>

      <span>
        <Caixa
          ID="Limeira"
          Titulo="Limeira"
          Top="104"
          Left="1514"
          Height="50"
          Width="178"
          Angle="0"
          :Enabled="false"
        />
      </span>
    </div>
  </div>
</template>

<script>
import Reservatorio from "../components/Reservatorio.vue";
import Bomba from "../components/Bomba.vue";
import BombaPoco from "../components/BombaPoco.vue";
import Cano from "../components/Cano.vue";
import Juncao from "../components/Juncao.vue";
import Distribuicao from "../components/Distribuicao.vue";
import Caixa from "../components/Caixa.vue";
import datas from "../services/datas";

export default {
  /* eslint no-console: ["error", { allow: ["info", "warn", "error"] }] */
  name: "Distritos",
  components: {
    Reservatorio,
    Bomba,
    BombaPoco,
    Cano,
    Caixa,
    Juncao,
    Distribuicao
  },
  props: {
    img: String
  },
  data: function() {
    return {
      pontosDistritos: JSON.parse(
        window.localStorage.getItem("pontosDistritos")
      ),
      loop: null
    };
  },
  methods: {
    listarPontos() {
      datas
        .listar("tabPage2")
        .then(response => {
          response.data.map(x => {
            if (x.type == "TANQUE") {
              if (x.max_reservatorio == null) x.max_reservatorio = 1;
              if (x.value == null) x.value = 0;
            }
            return x;
          });
          this.pontosDistritos = response.data;
          window.localStorage.setItem(
            "pontosDistritos",
            JSON.stringify(response.data)
          );
        })
        .catch(error => {
          console.warn(`Falha ao consumir a API!\n${error}`);
        });
    }
  },
  mounted() {
    this.listarPontos();
    clearInterval(this.loop);
    this.loop = setInterval(() => {
      this.listarPontos();
    }, 1000 * 15);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
